module.exports = __webpack_public_path__ + "4c6f7a7828f71b4a9dfd00570279f460.webm";